import Carousel from 'react-bootstrap/Carousel';
import React, { useState } from "react";


const DcmCarousel = ({ simulation, playing, interactive}) => {

    const [dcmArray, setDcmArray] = useState(Array.from(Array(simulation.numberOfDicoms).keys()));


    return (
        <Carousel 
        slide={false} // No animation
        autoPlay={true} 
        interval={playing ? 50 : null}
        controls={interactive || !playing}
        pause={interactive ? 'hover' : false}
        indicators={false}
        >

            { dcmArray.map((dcmi) => (
                <Carousel.Item key={'CarouselImg'+simulation.id+'_'+dcmi}>

                    <img
                        className="d-block w-100"
                        src={'/api/download/trainee/' + simulation.id + '/DCM' + dcmi}
                        alt="Vessel images"
                    />

                </Carousel.Item>
            )) }
        </Carousel>
    );
}

export default DcmCarousel;


